import { z } from 'zod';
import { applicationSchema } from '../types/applications';
import { UserAuditSchema } from '../types/user';
import { AccountAuditSchema } from '../types/account';
import { StatusEnum, StatusTypeSchema } from '../enums/status';
import { FeatureDetailSchema } from '../types/features';

export namespace CreateApplication {
  export const requestBodySchema = z.object({
    application: applicationSchema.omit({ id: true, createdOn: true, identifier: true, createdBy: true, status: true }),
  });
  export type RequestBody = z.infer<typeof requestBodySchema>;

  export const responseSchema = z.object({ application: applicationSchema });
  export type Response = z.infer<typeof responseSchema>;
}

export namespace GetApplications {
  export const responseSchema = z.object({
    applications: z.array(applicationSchema),
  });
  export type Response = z.infer<typeof responseSchema>;
}

export namespace GetApplication {
  export const paramsSchema = z.object({
    id: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const responseSchema = z.object({
    application: applicationSchema.extend({
      brands: z.array(z.object({
        id: z.number(),
        name: z.string(),
      })),
    }),
    features: z.array(FeatureDetailSchema),
  });
  export type Response = z.infer<typeof responseSchema>;
}

export namespace GetApplicationUsers {
  export const paramsSchema = z.object({
    id: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const responseSchema = z.object({
    users: z.array(UserAuditSchema),
  });
  export type Response = z.infer<typeof responseSchema>;
}

export namespace GetApplicationAccounts {
  export const paramsSchema = z.object({
    id: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const responseSchema = z.object({
    accounts: z.array(AccountAuditSchema),
  });
  export type Response = z.infer<typeof responseSchema>;
}
export namespace UpdateApplication {
  export const paramsSchema = z.object({
    id: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const requestBodySchema = z.object({
    application: applicationSchema.omit({ id: true, createdOn: true, identifier: true, createdBy: true, status: true }),
  });
  export type RequestBody = z.infer<typeof requestBodySchema>;

  export const responseSchema = z.object({ application: applicationSchema });
  export type Response = z.infer<typeof responseSchema>;
}

export namespace UpdateApplicationStatus {
  export const paramsSchema = z.object({
    id: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const requestBodySchema = z.object({
    status: StatusTypeSchema,
  });
  export type RequestBody = z.infer<typeof requestBodySchema>;

  export const responseSchema = z.object({ application: applicationSchema });
  export type Response = z.infer<typeof responseSchema>;
} 

export const getApplicationChatContextsRequestParamsSchema = z.object({
  applicationId: z.coerce.number(),
});
export const getApplicationChatContextsResponseBodySchema = z.object({
  chatContexts: z.array(z.object({
    id: z.number(),
    name: z.string(),
    createdOn: z.coerce.date(),
  })),
});

export const addApplicationChatContextRequestParamsSchema = z.object({
  applicationId: z.coerce.number(),
});
export const addApplicationChatContextRequestBodySchema = z.object({
  chatContextId: z.number(),
});

export const deleteApplicationChatContextRequestParamsSchema = z.object({
  applicationId: z.coerce.number(),
  chatContextId: z.coerce.number(),
});